import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditBlogCategory from "../../components/blog-categories/FormAddEditBlogCategory";

const CreateBlogCategory = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/blog/categories");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditBlogCategory isEdit={false} currentData={null} onSubmitSuccess={handleSuccess} />
        </WrapperSection>
    );
};

export default CreateBlogCategory;
